// extracted by mini-css-extract-plugin
export var backdropBlur = "_eo-0";
export var contentCard = "_eo-5";
export var frame = "_eo-2";
export var image = "_eo-4";
export var imagePane = "_eo-3";
export var modal = "_eo-1";